import { cn } from '@/lib/utils';

interface BrandMarkProps {
  tone?: 'dark' | 'light';
  className?: string;
}

/**
 * DreamPick wordmark. Uses the display serif for a distinctive premium feel.
 * `tone="light"` renders on dark surfaces (auth / footer).
 */
export function BrandMark({ tone = 'dark', className }: BrandMarkProps) {
  return (
    <div className={cn('inline-flex items-baseline gap-1', className)} data-testid="brand-mark">
      <span
        className={cn(
          'font-display text-2xl leading-none tracking-tight',
          tone === 'light' ? 'text-secondary-foreground' : 'text-foreground',
        )}
      >
        Dream
      </span>
      <span className="font-display text-2xl leading-none italic text-gold">Pick</span>
      <span className="ml-1 h-1.5 w-1.5 rounded-full bg-primary" aria-hidden />
    </div>
  );
}
